// extracted by mini-css-extract-plugin
export default {"greentechCertification":"greentechCertification_greentechCertification__gczyX"};